import React from 'react';
import { TopicStyles } from './mixins/mixins';
import { ClockTypes } from './mixins/optionsValues';
import {
	StyleDropdownMenu,
	StyleSlider,
	StyleToggle
} from './components/common';

export const ClockStyle = ({
	style,
	setStyle
}: {
	style: TopicStyles;
	setStyle: (style: TopicStyles) => void;
}) => {
	return (
		<div className="grid grid-cols-2 lg:grid-cols-3 justify-items-center gap-4">
			<StyleDropdownMenu
				key={'clock_kind'}
				name={'Clock Kind'}
				options={[
					{ name: 'Digital', value: ClockTypes.Digital },
					{ name: 'Analog', value: ClockTypes.Analog },
					{ name: 'Age Counter', value: ClockTypes.AgeCounter }
				]}
				optionState={style.clock.kind}
				handleChange={(value: any) => {
					setStyle({
						...style,
						clock: { ...style.clock, ['kind']: value }
					});
				}}
			/>

			<StyleSlider
				key={'clock-size-range'}
				id={'clock-size-range'}
				name={'Size'}
				initialValue={style.clock.size}
				minValue={'10'}
				maxValue={'80'}
				step={'5'}
				handleChange={({ value }: { value: any }) => {
					setStyle({
						...style,
						clock: { ...style.clock, ['size']: value }
					});
				}}
			/>

			{style.clock.kind === ClockTypes.Analog ? (
				<>
					<StyleToggle
						key={'clock_is_numbered'}
						style={style}
						styleObj={'clock'}
						parentStyle={style.clock}
						styleKey={'isNumbered'}
						name={'Is Numbered'}
						optionState={style.clock.isNumbered}
						setStyle={setStyle}
					/>

					<StyleToggle
						key={'clock_is_dark'}
						style={style}
						styleObj={'clock'}
						parentStyle={style.clock}
						styleKey={'isDark'}
						name={'Is Dark'}
						optionState={style.clock.isDark}
						setStyle={setStyle}
					/>

					<StyleToggle
						key={'clock_show_seconds_analog'}
						style={style}
						styleObj={'clock'}
						parentStyle={style.clock}
						styleKey={'showSeconds'}
						name={'Show Seconds'}
						optionState={style.clock.showSeconds}
						setStyle={setStyle}
					/>
				</>
			) : style.clock.kind === ClockTypes.Digital ? (
				<>
					<StyleToggle
						key={'clock_show_am_pm'}
						style={style}
						styleObj={'clock'}
						parentStyle={style.clock}
						styleKey={'showAmPm'}
						name={'Show AM/PM'}
						optionState={style.clock.showAmPm}
						setStyle={setStyle}
					/>

					<StyleToggle
						key={'clock_show_twenty_four'}
						style={style}
						styleObj={'clock'}
						parentStyle={style.clock}
						styleKey={'showTwentyFour'}
						name={'Show 24h format'}
						optionState={style.clock.showTwentyFour}
						setStyle={setStyle}
					/>

					<StyleToggle
						key={'clock_show_seconds_digital'}
						style={style}
						styleObj={'clock'}
						parentStyle={style.clock}
						styleKey={'showSeconds'}
						name={'Show Seconds'}
						optionState={style.clock.showSeconds}
						setStyle={setStyle}
					/>

					<StyleSlider
						key={'clock-boldness_digital'}
						id={'clock-boldness-range'}
						name={'Boldness'}
						initialValue={style.clock.boldness}
						minValue={'0'}
						maxValue={'100'}
						step={'5'}
						handleChange={({ value }: { value: any }) => {
							setStyle({
								...style,
								clock: { ...style.clock, ['boldness']: value }
							});
						}}
					/>
				</>
			) : (
				<StyleSlider
					key={'clock-boldness_age'}
					id={'clock-boldness-range'}
					name={'Boldness'}
					initialValue={style.clock.boldness}
					minValue={'0'}
					maxValue={'100'}
					step={'5'}
					handleChange={({ value }: { value: any }) => {
						setStyle({
							...style,
							clock: { ...style.clock, ['boldness']: value }
						});
					}}
				/>
			)}
		</div>
	);
};
